module.exports = __webpack_public_path__ + "img/BtnClose.f58e9f92.png";